import { useToggle } from 'usehooks-ts';
import { Label } from '@progress/kendo-react-labels';

import CustomColumnContainer, {
  CustomColumnProps
} from './custom-column-container';
import MediaPreviewDialog from '../../dialogs/media-preview-dialog';

interface CustomColumnVideoProps extends CustomColumnProps {
  id?: string;
  url?: string;
  maxHeight?: number;
  label?: string;
  onEdit?: (id?: string) => void;
}

const CustomColumnVideo = ({
  onEdit = () => {},
  ...props
}: CustomColumnVideoProps) => {
  const [displayPreview, setDisplayPreview] = useToggle();

  const onEditHandler = (id: string) => {
    onEdit(id);
  };

  return (
    <CustomColumnContainer
      columnClass={props?.columnClass}
      containerClass={props?.containerClass}>
      {props.label && <Label editorId={props.id}>{props.label}</Label>}
      <div className={'d-flex w-full p-2'}>
        <div className={'w-100'}>
          {!props?.url && <span>No video found</span>}
          {props?.url && props?.url !== '' && (
            <div
              onClick={setDisplayPreview}
              className={
                'mask d-flex align-items-center justify-content-center'
              }
              style={{
                backgroundImage: `url(${props.url})`,
                backgroundPosition: 'center',
                height: 100,
                width: 100
              }}>
              <button className={'btn text-light'}>
                <span className={'material-symbols-outlined'}>play_arrow</span>
              </button>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center">
          <span
            onClick={() => onEditHandler(props.id!)}
            className={'material-symbols-outlined'}
            style={{ cursor: 'pointer' }}>
            edit
          </span>
        </div>
      </div>

      {displayPreview && (
        <MediaPreviewDialog
          title={props.label ?? 'Media Preview'}
          mediaType={'video'}
          mediaUrl={props.url ?? ''}
          onClose={setDisplayPreview}
        />
      )}
    </CustomColumnContainer>
  );
};

export default CustomColumnVideo;
